import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { View, FlatList, ScrollView } from 'react-native'
import { Txt, LaneCard } from '../../../../components'
import Spinner from '../../../../components/Spinner'
import { preferredLaneSelector } from '../../../../redux/preferredLane/preferredLaneSelector'
import styles from './styles'

const PreferredLanesList = ({ editLane, deleteLane, invalidLanes }) => {
  const { preferredLanes, fethLoading } = useSelector(preferredLaneSelector)

  const laneKeyExtractor = useCallback((lane) => lane.lane_id, [])

  return (
    <View style={styles.container}>
      {fethLoading ? (
        <Spinner />
      ) : preferredLanes.length ? (
        <ScrollView>
          <FlatList
            data={preferredLanes}
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{ padding: 5 }}
            renderItem={({ item, index }) => (
              <LaneCard
                lane={item}
                editLane={editLane}
                deleteLane={deleteLane}
                index={index}
                invalid={invalidLanes.includes(index)}
              />
            )}
            keyExtractor={laneKeyExtractor}
            testID='preferredLanesHeaderOnGoBackButton'
            accessibilityLabel='preferredLanesList'
          />
        </ScrollView>
      ) : (
        <Txt
          Key='noPrederredLanesMessage'
          text='No preferred lanes found'
          identity='subtitle'
          color='OUTER_SPACE'
        />)}
    </View>
  )
}

PreferredLanesList.propTypes = {
  editLane: PropTypes.func,
  deleteLane: PropTypes.func,
  invalidLanes: PropTypes.array
}

PreferredLanesList.defaultProps = {
  editLane: () => {},
  deleteLane: () => {},
  invalidLanes: []
}

export default PreferredLanesList
